import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import API from 'api/API';
import { useAuth } from 'providers/AuthContextProvider'; 
import { CircularProgress, FormLabel, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { isValidCurp } from 'utils/isValidCurp';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.cardexmedico.com.mx">
        cardexmedico
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [snackbarState, setSnackbarState] = React.useState({open: false, message: "", status: "info"});
  const {login} = useAuth();
  const [showPassword, setShowPassword] = React.useState(false);
  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  
  const handleSubmit = async(event) => {
    event.preventDefault();
    
    const data = new FormData(event.currentTarget);
    
    const curp = data.get('curp')
    const password = data.get('password')

    if(curp.length == 0 || password.length == 0){
      setSnackbarState({open:true, message:"Fill email and password fields.", status:"warning"})
      return
    }

    if(!isValidCurp(curp)){
      setSnackbarState({open:true, message:"Proporciona un CURP valida", status:"warning"})
      return
    }
    
    const requestBody = {
      curp: curp.toLowerCase(),
      password: password
    }
    setLoading(true)
    const response = await API.postLogin(requestBody)
    setLoading(false)
    if(response.status == 200){
        login(response.data.user, response.data.authToken, response.data.refreshToken); 
        setSnackbarState({open:true, message: response.message, status: "success"})
        navigate('/sons');
    }else{
        setSnackbarState({open:true, message: response.message, status: "error"})
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
  };

  return (

      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2F14933.jpg?alt=media&token=8cbcf2d8-e15d-47c9-b863-96eeeb8b1dd4')",
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'top',
          }} 
        >
        </Grid>
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '100%' }}}>
            <Box
                alignSelf= 'center'
                component="img"
                sx={{
                  height: 200,
                  width: 400,
                }}
                alt="officia logo."
                src="https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/logos%2Fcardex_medico_logo.png?alt=media&token=0ba70358-0587-41a6-a5cf-367f17fe8ac4"
              />
            </Stack>
            
            <Typography variant="h6" style={{marginTop:64}}>
              Comienza con tu CURP y contraseña
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="curp"
                label="CURP"
                name="curp"
                autoComplete="curp"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={showPassword ? 'text' : 'password'}
                id="password"
                autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleToggleVisibility}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
                <Link href="/password" variant="body2">
                  Forgot your password?
                </Link>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, position: 'relative' }}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Sign In'
                )}
              </Button>
              <Grid container>
                <Typography sx={{ textAlign: 'center' }}>
                  Don&apos;t have an account?{' '}
                  <span>
                    <Link
                      href="/registry"
                      variant="body2"
                      sx={{ alignSelf: 'center' }}
                    >
                      Sign up
                    </Link>
                  </span>
                </Typography>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState.open} onClose={handleClose}>
                  <Alert
                    onClose={handleClose}
                    severity={snackbarState.status}
                    variant="filled"
                  >
                    {snackbarState.message}
                  </Alert>
                </Snackbar>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
  );
}